import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@Component({
  selector: 'tool-loading',
  imports: [MatProgressSpinnerModule],
  templateUrl: './tool-loading.component.html',
  styleUrl: './tool-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolLoadingComponent {}
